import type { Sequence } from "../types/Sequence"
import { Zip } from "./Zip"

export const RecordCreate = <T>(
  keys: Sequence<string>,
  values: Sequence<T>
): Record<string, T> => Object.fromEntries(Zip(keys, values))
